import React from "react";
import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import { Application } from "./application";

export default class extends Controller {
  private root: ReturnType<typeof createRoot> | null = null;

  connect() {
    document.addEventListener("turbo:before-cache", this.beforeCache);

    if (!this.root) {
      this.root = createRoot(this.element as HTMLElement);
      this.root.render(<Application />);
    }
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache);

    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
  }

  beforeCache = () => {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
  };
}
